module.exports = __webpack_public_path__ + "img/investCover.00d60f5f.png";